/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersBudgetDto } from '../../models/users-budget-dto';

export interface UpdateMonthlyBudget$Params {
  year: number;
  month: number;
      body: Array<UsersBudgetDto>
}

export function updateMonthlyBudget(http: HttpClient, rootUrl: string, params: UpdateMonthlyBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UsersBudgetDto>>> {
  const rb = new RequestBuilder(rootUrl, updateMonthlyBudget.PATH, 'put');
  if (params) {
    rb.path('year', params.year, {});
    rb.path('month', params.month, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UsersBudgetDto>>;
    })
  );
}

updateMonthlyBudget.PATH = '/budget-management/{year}/{month}';
